import ComboChartWidgetRenderService from '@/modules/ta/legacy/widget/services/types/ComboChartWidgetRenderService';

export class LegacyComboChartWidgetRenderService extends ComboChartWidgetRenderService {
  /**
   * @var Widget
   */
  _widget;

  /**
   * @var array
   */
  _chartPalette;

  /**
   * @var boolean
   */
  _hasComparisonData;

  /**
   * @var boolean
   */
  _isExporting;

  /**
   * @var string
   */
  _backgroundColor;

  /**
   * @param widget
   * @param chartPalette {array}
   * @param hasComparisonData {boolean}
   * @param isExporting
   * @param backgroundColor
   */
  constructor(
    widget,
    chartPalette = [],
    hasComparisonData = false,
    isExporting = false,
    backgroundColor = null
  ) {
    super(widget.id);
    this._widget = widget;
    this._chartPalette = chartPalette;
    this._hasComparisonData = hasComparisonData;
    this._isExporting = isExporting;
    this._backgroundColor = backgroundColor;
  }

  /**
   * @returns {*}
   */
  getWidget() {
    return this._widget;
  }

  /**
   * @override
   * @returns {boolean}
   */
  isExporting() {
    return this._isExporting;
  }

  /**
   * @returns {*}
   */
  getFullChartPalette() {
    return this._chartPalette;
  }

  /**
   * @param columnIndex
   * @returns {string}
   */
  getChartPalette(columnIndex) {
    return this._chartPalette[columnIndex % this._chartPalette.length];
  }

  /**
   * @returns {{}}
   */
  getChartConfigProperties() {
    return {
      ...super.getChartConfigProperties(),
    };
  }

  /**
   * @returns {boolean}
   */
  hasComparison() {
    return this._hasComparisonData;
  }
}
